var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"stripe":"","header-cell-style":{
      background: '#B1B1B1',
      color: '#ffffff',
      textAlign: 'center',
      fontSize: '18px',
    },"cell-style":{ textAlign: 'center' }}},[_c('el-table-column',{attrs:{"type":"index","label":"序号","width":"100px"}}),_c('el-table-column',{attrs:{"prop":"XM","label":"姓名"}}),_c('el-table-column',{attrs:{"prop":"SSDW","label":"单位"}}),_c('el-table-column',{attrs:{"prop":"VIPZW","label":"职务"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }